import './clientEntry';

import { buildClientApp, generateCarleadCreationConfig } from '@retail/funnel-components';
import clientRoutes from './clientRoutes';
import { messages as retailMessages } from '../translations/autohero-common/sv-se/messages';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/sv-se/messages';
import { funnelOptions } from './funnelOptions';
import pckJson from '../package.json';

const appConfig = generateCarleadCreationConfig('sv-SE', pckJson, funnelOptions);

buildClientApp(appConfig, clientRoutes, {
  ...retailMessages,
  ...sellOnlyMessages,
});
